import request from '@/utils/request'

// v80WeldEmp
export function v80WeldEmp(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080Pop/v80WeldEmp`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// addList
export function addList(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080Pop/addList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getInsSeqNDT
export function getInsSeqNDT(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080Pop/getInsSeqNDT`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1080SaveNDT
export function v80a1080SaveNDT(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080Pop/v80a1080SaveNDT`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1080SaveNDT2
export function v80a1080SaveNDT2(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080Pop/v80a1080SaveNDT2`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getPorNoList
export function getPorNoList(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080Pop/getPorNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getBlockList
export function getBlockList(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080Pop/getBlockList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
